import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API, useAuth, getDashboardRoute } from "../App";

const AuthCallback = () => {
  const { processGoogleSession, processGoogleToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get("code");
        const state = params.get("state");
        if (code && state) {
          window.location.href = `${API}/auth/google/callback${location.search}`;
          return;
        }

        const token = params.get("token");
        if (token) {
          window.history.replaceState({}, "", "/auth/callback");
          const data = await processGoogleToken(token);
          if (data.user.needs_role_selection) {
            navigate("/select-role", { replace: true });
          } else {
            const dashboardRoute = getDashboardRoute(data.user.role);
            navigate(dashboardRoute, { replace: true, state: { user: data.user } });
          }
          return;
        }

        // Extract session_id from URL hash
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error("No session_id found in URL");
          navigate("/login", { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Process the session
        const data = await processGoogleSession(sessionId);
        
        // Redirect to role selection if needed, otherwise to dashboard
        if (data.user.needs_role_selection) {
          navigate("/select-role", { replace: true });
        } else {
          const dashboardRoute = getDashboardRoute(data.user.role);
          navigate(dashboardRoute, { replace: true, state: { user: data.user } });
        }
      } catch (error) {
        console.error("Failed to process Google session:", error);
        navigate("/login", { replace: true });
      }
    };

    processSession();
  }, [location.hash, location.search, navigate, processGoogleSession, processGoogleToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="loading-spinner border-blue-500 mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
